import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';
import { UserRoleName } from '../identity/types/UserProfile';

import { client } from '../client';

export const getConversationToken = async (userRole?: string): Promise<string> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const url = prefix ? `${prefix}/chat/access_token` : '/messages/access_token';
  try {
    const { data } = await client.post(url, {});
    return data.access_token;
  } catch (error: any) {
    if (!prefix && (!userRole || userRole === UserRoleName.Collector) && error?.response?.status === 403) {
      const collectorPrefix = getStaffScopedApiPrefix(UserRoleName.Collector);
      const { data } = await client.post(`${collectorPrefix}/chat/access_token`, {});
      return data.access_token;
    }
    throw error;
  }
};
